import React from "react";

const Logo = () => {
  return (
    <svg
      className="App-logo"
      width="748"
      height="1185"
      viewBox="0 0 748 1185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="logo">
        <circle
          id="circle"
          cx="350"
          cy="350"
          r="320"
          stroke="url(#paint0_linear)"
          stroke-width="60"
        />
        <path
          id="Question-markr"
          d="M670.75 589.294C655.533 563.543 635.39 541.081 610.758 522.667C560.702 485.115 497.707 468.14 433.542 474.884C369.377 481.628 311.289 511.33 270.125 558.379C249.869 581.601 234.827 607.672 225.306 636.112C215.375 665.757 211.985 696.413 215.237 727.353L218.188 755.432C218.919 762.394 221.354 761.635 227.922 761.95L238.024 762.397L252.602 762.373L264.641 762.113L277.072 760.806C282.552 760.23 285.845 749.606 285.269 744.125L282.76 720.256C273.515 632.296 344.305 552.549 440.641 542.423C536.977 532.298 622.8 595.585 632.045 683.545C635.836 719.613 626.589 754.906 605.257 785.749C584.162 816.299 552.333 839.934 515.663 852.368C494.697 859.488 476.614 873.633 464.736 892.4C452.9 911.102 447.704 933.247 449.987 955.264L452.904 983.022C453.48 988.503 458.364 992.458 463.844 991.882L511.57 986.866C517.05 986.29 521.004 981.406 520.428 975.925L517.511 948.167C516.052 934.288 524.403 921.076 537.433 916.667C587.821 899.573 631.737 866.803 661.145 824.386C675.954 802.898 686.819 779.59 693.423 754.853C700.287 729.195 702.338 702.792 699.569 676.448C696.317 645.507 686.618 616.138 670.75 589.294ZM495.051 1060.11C467.742 1062.98 447.89 1087.5 450.761 1114.81C453.632 1142.13 478.148 1161.99 505.458 1159.12C532.768 1156.25 552.62 1131.72 549.749 1104.41C546.878 1077.09 522.361 1057.23 495.051 1060.11Z"
          fill="url(#paint1_linear)"
        />
        <path
          id="half-circle"
          d="M380 668C175 684 30 525.627 30 350C30 174.373 186.7 32 380 32"
          stroke="url(#paint2_linear)"
          stroke-width="60"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="350"
          y1="0"
          x2="350"
          y2="700"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#88BFFF" />
          <stop offset="1" stop-color="#003B80" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="543.763"
          y1="389.898"
          x2="252.466"
          y2="794.563"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#88BFFF" />
          <stop offset="1" stop-color="#0055B9" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="205"
          y1="32"
          x2="205"
          y2="668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#88BFFF" />
          <stop offset="1" stop-color="#003B80" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;
